var map = {
	"./account/benefit-unlocked.svg": 79947,
	"./account/complete.svg": 64151,
	"./account/course/add.svg": 3722,
	"./account/email.svg": 52311,
	"./account/eye.svg": 4372,
	"./account/input-error.svg": 18800,
	"./account/letter.svg": 35536,
	"./account/link.svg": 74817,
	"./account/lock.svg": 76421,
	"./account/locked.svg": 73242,
	"./account/person.svg": 42590,
	"./account/plus.svg": 12078,
	"./account/remove.svg": 31537,
	"./account/selected.svg": 92013,
	"./account/settings.svg": 11315,
	"./account/tick.svg": 91881,
	"./account/unselected.svg": 86229,
	"./account/warning.svg": 9042,
	"./add-more.svg": 10739,
	"./add-text.svg": 68090,
	"./add-word.svg": 59582,
	"./alert-24x24.svg": 63396,
	"./alert-white-24x24.svg": 27797,
	"./arrow-2.svg": 23572,
	"./arrow-3.svg": 19959,
	"./arrow-card.svg": 79595,
	"./arrow-down-purple.svg": 28253,
	"./arrow-down.svg": 25666,
	"./arrow-large.svg": 27620,
	"./arrow-narrow.svg": 32896,
	"./arrow-nav.svg": 959,
	"./arrow.svg": 1384,
	"./arrows/arrow-down.svg": 1366,
	"./arrows/arrow-up.svg": 76928,
	"./auth_provider/login_button_logo_apple.svg": 97055,
	"./auth_provider/login_button_logo_email.svg": 71675,
	"./auth_provider/login_button_logo_facebook.svg": 95068,
	"./auth_provider/login_button_logo_feide.svg": 8054,
	"./auth_provider/login_button_logo_google.svg": 64702,
	"./auth_provider/login_button_logo_weibo.svg": 72757,
	"./back-arrow-20x20.svg": 21420,
	"./button-arrow-active.svg": 78742,
	"./button-arrow.svg": 87650,
	"./button-decoration/correct.svg": 92934,
	"./button-decoration/incorrect.svg": 83379,
	"./button-decoration/unselected.svg": 26377,
	"./capslock-on.svg": 58206,
	"./card/arrow.svg": 86277,
	"./card/audio-button.svg": 81945,
	"./card/context-translation-button-icon.svg": 16681,
	"./card/correct-tick.svg": 61534,
	"./card/try-again-button.svg": 35940,
	"./challenges/article/huffpost.svg": 96792,
	"./challenges/article/story-each-day.svg": 50418,
	"./challenges/article/tipsy-gypsies.svg": 15952,
	"./challenges/conversation/back-arrow.svg": 59838,
	"./challenges/conversation/notification/activity-done.svg": 63563,
	"./challenges/conversation/notification/broken-mic.svg": 8921,
	"./challenges/conversation/recorder/play.svg": 86774,
	"./challenges/conversation/recorder/record.svg": 95422,
	"./challenges/filters/all-active.svg": 39256,
	"./challenges/filters/all.svg": 54322,
	"./challenges/filters/grammar-active.svg": 55550,
	"./challenges/filters/grammar.svg": 50878,
	"./challenges/filters/listen-active.svg": 80551,
	"./challenges/filters/listen.svg": 65385,
	"./challenges/filters/read-active.svg": 42546,
	"./challenges/filters/read.svg": 42398,
	"./challenges/filters/speak-active.svg": 76623,
	"./challenges/filters/speak.svg": 46379,
	"./challenges/linguistica360/french.svg": 33137,
	"./challenges/linguistica360/german.svg": 170,
	"./challenges/linguistica360/spanish.svg": 58231,
	"./challenges/multiple-choice/pause.svg": 23798,
	"./challenges/multiple-choice/play.svg": 61734,
	"./challenges/reading/illustration.svg": 4760,
	"./chevron-primary.svg": 1028,
	"./chevron-right-16.svg": 15781,
	"./classroom/download-icon.svg": 10131,
	"./classroom/join-illustration.svg": 56267,
	"./close-20x20.svg": 44144,
	"./close-24x24-whitespace.svg": 56847,
	"./close-24x24.svg": 57424,
	"./close.svg": 42040,
	"./collapse.svg": 43594,
	"./continue-20x20.svg": 53040,
	"./course-wizard/card-status/status-all.svg": 83915,
	"./course-wizard/card-status/status-complete.svg": 66452,
	"./course-wizard/card-status/status-incomplete-known.svg": 68731,
	"./course-wizard/card-status/status-incomplete.svg": 54113,
	"./course-wizard/card-status/status-invalid.svg": 34846,
	"./course-wizard/card-status/status-known.svg": 9817,
	"./course-wizard/intro-arrow.svg": 99549,
	"./course-wizard/intro-illustration.svg": 88992,
	"./cross.svg": 20786,
	"./diacritics/az.svg": 29642,
	"./diacritics/cs.svg": 83092,
	"./diacritics/da.svg": 89833,
	"./diacritics/de.svg": 94209,
	"./diacritics/es.svg": 41439,
	"./diacritics/et.svg": 22079,
	"./diacritics/fr.svg": 74067,
	"./diacritics/hr.svg": 97712,
	"./diacritics/it.svg": 56259,
	"./diacritics/nl.svg": 18556,
	"./diacritics/no.svg": 84561,
	"./diacritics/pl.svg": 86250,
	"./diacritics/pt.svg": 92090,
	"./diacritics/sk.svg": 3762,
	"./diacritics/sv.svg": 42189,
	"./diacritics/tr.svg": 43837,
	"./difficulty-16x16.svg": 47333,
	"./doorslam/course-end.svg": 42867,
	"./doorslam/illustration_knowledge_mapping_end_light.svg": 16047,
	"./doorslam/published.svg": 84627,
	"./doorslam/publishing.svg": 21854,
	"./doorslam/sets/set-1.svg": 3702,
	"./doorslam/sets/set-2+.svg": 7412,
	"./doorslam/sets/set-2.svg": 65726,
	"./doorslam/sets/study-day-1.svg": 32475,
	"./doorslam/sets/study-day-2.svg": 90380,
	"./doorslam/sets/study-day-3.svg": 10121,
	"./doorslam/sets/study-day-4.svg": 94600,
	"./edit.svg": 33438,
	"./email-verified.svg": 12953,
	"./emojis/awesome-32.svg": 86022,
	"./emojis/happy-32.svg": 25308,
	"./emojis/mad-32.svg": 89360,
	"./emojis/neutral-32.svg": 58180,
	"./emojis/unhappy-32.svg": 72392,
	"./error.svg": 71046,
	"./expand.svg": 68957,
	"./fast_tracking/dot.svg": 7153,
	"./fast_tracking/i.svg": 41435,
	"./fast_tracking/intro-2.svg": 41243,
	"./fast_tracking/no_ft.svg": 37922,
	"./fast_tracking_dot.svg": 52309,
	"./fav-checked.svg": 29375,
	"./fav-unchecked.svg": 91231,
	"./feedback-flag.svg": 93866,
	"./feedback.svg": 68790,
	"./file-40x40.svg": 65664,
	"./file-image-32.svg": 98389,
	"./file-text-32.svg": 5358,
	"./flags/flag_ar.svg": 75207,
	"./flags/flag_az.svg": 67755,
	"./flags/flag_br.svg": 6963,
	"./flags/flag_cn.svg": 21118,
	"./flags/flag_cz.svg": 55666,
	"./flags/flag_da.svg": 28357,
	"./flags/flag_de.svg": 37357,
	"./flags/flag_ee-taxi_42x26.svg": 96720,
	"./flags/flag_ee.svg": 22789,
	"./flags/flag_es-us.svg": 25190,
	"./flags/flag_es.svg": 52075,
	"./flags/flag_fi.svg": 86784,
	"./flags/flag_fr.svg": 63107,
	"./flags/flag_gb.svg": 53499,
	"./flags/flag_hr.svg": 40554,
	"./flags/flag_id.svg": 69146,
	"./flags/flag_in.svg": 67752,
	"./flags/flag_it.svg": 4979,
	"./flags/flag_jp.svg": 37379,
	"./flags/flag_kr.svg": 46381,
	"./flags/flag_my.svg": 88690,
	"./flags/flag_mystery_42x26.svg": 52276,
	"./flags/flag_nl.svg": 54649,
	"./flags/flag_no.svg": 50176,
	"./flags/flag_pirate.svg": 32831,
	"./flags/flag_pl.svg": 274,
	"./flags/flag_pt.svg": 16184,
	"./flags/flag_ru.svg": 36637,
	"./flags/flag_sk.svg": 96880,
	"./flags/flag_sv.svg": 67163,
	"./flags/flag_th.svg": 66276,
	"./flags/flag_toefl-ja.svg": 93571,
	"./flags/flag_toeic.svg": 99308,
	"./flags/flag_tr.svg": 72482,
	"./flags/flag_tw.svg": 93649,
	"./flags/flag_ua.svg": 86323,
	"./flags/flag_us-gb.svg": 20309,
	"./flags/flag_us.svg": 67360,
	"./flags/flag_zh-Hans.svg": 33646,
	"./flags/flag_zh-Hant.svg": 46329,
	"./generic/audio-inprogress.svg": 13294,
	"./generic/audio.svg": 1471,
	"./grammar-icon/feminine_invariable_plurality.svg": 20149,
	"./grammar-icon/feminine_neutral_plurality.svg": 78736,
	"./grammar-icon/feminine_plural.svg": 92720,
	"./grammar-icon/feminine_singular.svg": 23534,
	"./grammar-icon/masculine_feminine_plural.svg": 76352,
	"./grammar-icon/masculine_feminine_singular.svg": 4898,
	"./grammar-icon/masculine_invariable_plurality.svg": 31459,
	"./grammar-icon/masculine_plural.svg": 31610,
	"./grammar-icon/masculine_singular.svg": 28660,
	"./grammar-icon/neutral_invariable_plurality.svg": 76821,
	"./grammar-icon/neutral_plural.svg": 87824,
	"./grammar-icon/neutral_singular.svg": 65434,
	"./guess-onboarding-icon.svg": 20877,
	"./header/logo.svg": 74075,
	"./help-24x24.svg": 5724,
	"./help/icon/bug.svg": 54864,
	"./help/icon/feedback.svg": 42172,
	"./help/icon/letter.svg": 95758,
	"./help/magnifying-glass.svg": 84102,
	"./home-drawer/logo-free.svg": 94940,
	"./home-drawer/logo-icon.svg": 55424,
	"./home-drawer/logo-text.svg": 46849,
	"./home-drawer/logo-unlimited.svg": 10504,
	"./ic_ascending.svg": 43649,
	"./ic_descending.svg": 36452,
	"./ic_utility_right_light.svg": 80688,
	"./icons/demographic-icons/age-18-24.svg": 82316,
	"./icons/demographic-icons/age-18.svg": 42193,
	"./icons/demographic-icons/age-25-34.svg": 56773,
	"./icons/demographic-icons/age-35-44.svg": 31757,
	"./icons/demographic-icons/age-45-54.svg": 68434,
	"./icons/demographic-icons/age-55-64.svg": 84741,
	"./icons/demographic-icons/age-65.svg": 20968,
	"./icons/demographic-icons/app-store.svg": 30765,
	"./icons/demographic-icons/blog-post.svg": 37572,
	"./icons/demographic-icons/brain-training.svg": 72862,
	"./icons/demographic-icons/career.svg": 66165,
	"./icons/demographic-icons/demographic-other.svg": 13362,
	"./icons/demographic-icons/enjoy-learning.svg": 51079,
	"./icons/demographic-icons/friends-family.svg": 88315,
	"./icons/demographic-icons/integrate-country.svg": 13831,
	"./icons/demographic-icons/love-country.svg": 87972,
	"./icons/demographic-icons/online-ads.svg": 62009,
	"./icons/demographic-icons/pass-exam.svg": 61138,
	"./icons/demographic-icons/podcast.svg": 47991,
	"./icons/demographic-icons/set-goal.svg": 14028,
	"./icons/demographic-icons/social-media.svg": 28375,
	"./icons/demographic-icons/upcoming-trip.svg": 70085,
	"./icons/demographic-icons/web-search.svg": 32286,
	"./icons/demographic-icons/you-tube.svg": 95128,
	"./icons/icon-home-drawer-newwords.svg": 98492,
	"./icons/icon-hub-totalwords.svg": 56564,
	"./icons/icon-hub-wordsatrisk.svg": 59573,
	"./illustrated-dialog/blocked_feature.svg": 25162,
	"./illustrated-dialog/blocked_feature_with_trial.svg": 48151,
	"./illustrated-dialog/lexical_decision_exercise.svg": 55952,
	"./illustrated-dialog/new_course.svg": 87224,
	"./illustrated-dialog/referral_loop.svg": 69280,
	"./illustrated-dialog/trial_available.svg": 35564,
	"./illustrated-dialog/trial_end.svg": 49390,
	"./illustration_fast_tracking_light.svg": 74832,
	"./illustration_feedback_graditude_light.svg": 23571,
	"./insights/ic_stats_cards_answered.svg": 94067,
	"./insights/ic_stats_correct_rate.svg": 898,
	"./insights/ic_stats_first_try_correct.svg": 90606,
	"./insights/ic_stats_learned_trending_down.svg": 25497,
	"./insights/ic_stats_learned_trending_up.svg": 26524,
	"./insights/ic_stats_learned_words.svg": 50130,
	"./insights/ic_stats_mastered_light.svg": 29349,
	"./insights/ic_stats_not_seen_light.svg": 96637,
	"./insights/ic_stats_progressing_light.svg": 73288,
	"./insights/ic_stats_repeats_light.svg": 27186,
	"./insights/ic_stats_time_spent_light.svg": 94122,
	"./insights/ic_stats_total_days_learnt.svg": 30262,
	"./insights/ic_stats_unique_words.svg": 74930,
	"./insights/ic_stats_words_reinforced.svg": 64338,
	"./insights/ic_stats_words_to_learn.svg": 91379,
	"./insights/ic_zoom_in.svg": 74399,
	"./insights/ic_zoom_out.svg": 30922,
	"./insights/weekly_goal_pill_inactive_light.svg": 10336,
	"./key-backspace.svg": 39988,
	"./key-return.svg": 81423,
	"./keyboard.svg": 83300,
	"./lang_ind_arrow.svg": 6425,
	"./language-unknown-24x24.svg": 68390,
	"./learn/change_picture_24x24.svg": 33770,
	"./learn/logo-small.svg": 22697,
	"./learn/tick-correct.svg": 70694,
	"./locked-40x40.svg": 89588,
	"./logo-text.svg": 25285,
	"./logo.svg": 79155,
	"./magnifying-glass.svg": 85950,
	"./menu/account.svg": 93917,
	"./menu/audio.svg": 6506,
	"./menu/cards.svg": 7360,
	"./menu/challenges.svg": 66076,
	"./menu/classrooms.svg": 10716,
	"./menu/exercises.svg": 70960,
	"./menu/grammar-tips.svg": 68958,
	"./menu/help.svg": 83533,
	"./menu/home.svg": 27137,
	"./menu/hub.svg": 99629,
	"./menu/insights.svg": 82605,
	"./menu/lessons-creator.svg": 97818,
	"./menu/listen.svg": 20140,
	"./menu/menu.svg": 65446,
	"./menu/my-progress.svg": 75650,
	"./menu/pay.svg": 81400,
	"./menu/settings.svg": 47325,
	"./mic-24x24-active.svg": 68033,
	"./mic-24x24-dark.svg": 23433,
	"./mic-24x24.svg": 57766,
	"./more-circle.svg": 86795,
	"./more-dots-vertical.svg": 19022,
	"./more-dots.svg": 20481,
	"./mute-24x24.svg": 18852,
	"./new-email-icon.svg": 38239,
	"./new-password-icon.svg": 98234,
	"./notifications/tick.svg": 2182,
	"./onboarding/arrow.svg": 21094,
	"./onboarding/badge.svg": 6995,
	"./onboarding/conversation-microphone-disabled.svg": 94746,
	"./onboarding/conversation-microphone.svg": 31010,
	"./onboarding/conversation-speaking-face.svg": 98604,
	"./onboarding/push-notifications.svg": 88418,
	"./onboarding/tooltip-badge.svg": 57478,
	"./onboarding/welcome-back.svg": 63639,
	"./open-sidebar.svg": 31886,
	"./paperclip.svg": 92554,
	"./pay/faq-light.svg": 55417,
	"./pay/featured-in/alexa-next-stage-logo.svg": 10295,
	"./pay/featured-in/aljazeera-logo.svg": 26814,
	"./pay/featured-in/deutche-welle-logo.svg": 34055,
	"./pay/featured-in/huffpost-logo.svg": 29034,
	"./pay/featured-in/lifehacker-logo.svg": 62195,
	"./pay/featured-in/time-logo.svg": 63412,
	"./pay/featured-in/venturebeat-logo.svg": 29702,
	"./pay/featured-in/zdnet-logo.svg": 7420,
	"./pay/ic_voucher_24x24.svg": 83762,
	"./pay/illustrations/payment_failed.svg": 45922,
	"./pay/illustrations/payment_successful.svg": 81365,
	"./pay/illustrations/voucher-page-illustration.svg": 47791,
	"./pay/intro/build-vocabulary.svg": 10317,
	"./pay/intro/learn-everywhere.svg": 6919,
	"./pay/intro/learn-faster.svg": 18756,
	"./pay/intro/progress.svg": 50981,
	"./pay/intro/science.svg": 97562,
	"./pay/intro/start-at-your-level.svg": 51259,
	"./pay/intro/study-what-you-want.svg": 92846,
	"./pay/intro/vocabularies-for-you.svg": 96445,
	"./pay/locked.svg": 69692,
	"./pay/order-success.svg": 82368,
	"./pay/secure/cancel-anytime.svg": 96150,
	"./pay/secure/no-ads.svg": 96582,
	"./pay/secure/secure-payment.svg": 64183,
	"./pay/start-free-trial.svg": 3381,
	"./pay/voucher-illustration.svg": 39792,
	"./pin.svg": 90446,
	"./plus.svg": 87598,
	"./progress/goals/cards-done.svg": 47749,
	"./progress/goals/cards-not-done.svg": 18934,
	"./progress/goals/exercises-done.svg": 72340,
	"./progress/goals/exercises-not-done.svg": 60554,
	"./progress/goals/repeats-disabled.svg": 79619,
	"./progress/goals/repeats.svg": 32265,
	"./progress/goals/sets/dont-overdo.svg": 10710,
	"./progress/goals/words-done-10.svg": 5803,
	"./progress/goals/words-done.svg": 82638,
	"./progress/goals/words-not-done-10.svg": 75058,
	"./progress/goals/words-not-done.svg": 94771,
	"./progress/milestone.svg": 65911,
	"./progress/navigate-milestone-left.svg": 88781,
	"./progress/navigate-milestone-right.svg": 92337,
	"./progress/small-graph-illustration.svg": 25188,
	"./progress/under-construction.svg": 86006,
	"./progress/vocabulary-list.svg": 28196,
	"./read.svg": 21663,
	"./register/course_arrow.svg": 48936,
	"./register/referral.svg": 15576,
	"./reload.svg": 85886,
	"./remove.svg": 46006,
	"./report-24x24.svg": 98190,
	"./sentence-24x24.svg": 6740,
	"./settings-icon.svg": 84386,
	"./share.svg": 87804,
	"./slider-knob-32x32.svg": 54239,
	"./smiley.svg": 43633,
	"./sort.svg": 36101,
	"./speaker-24x24.svg": 5159,
	"./status-complete.svg": 9991,
	"./status-disabled.svg": 46227,
	"./status-locked.svg": 78956,
	"./status-unfinished.svg": 5982,
	"./status-unlimited.svg": 99968,
	"./student-cap-24x24.svg": 34218,
	"./survey-24.svg": 84983,
	"./survey-impact-24x24.svg": 19841,
	"./tick-17x16.svg": 36102,
	"./tick-24x24.svg": 93914,
	"./tick-green-24x24.svg": 54134,
	"./tick-light.svg": 61220,
	"./tick-round-light.svg": 60884,
	"./tick-round.svg": 8526,
	"./tick.svg": 89519,
	"./tip-24x24.svg": 60460,
	"./trash-24x24.svg": 8643,
	"./tutor-24x24.svg": 74329,
	"./tutor/meanings.svg": 4030,
	"./tutor/tables.svg": 80174,
	"./tutor/tips.svg": 44175,
	"./unlock-purple.svg": 86,
	"./updated_terms.svg": 61532,
	"./upload.svg": 14198,
	"./upsell-doorslam/challenge.svg": 11302,
	"./upsell-doorslam/challenges.svg": 65386,
	"./upsell-doorslam/end_of_course.svg": 7338,
	"./upsell-doorslam/end_of_course_essential_estonian.svg": 23363,
	"./upsell-doorslam/end_of_course_share.svg": 91655,
	"./upsell-doorslam/free_limit_reached.svg": 89655,
	"./upsell-doorslam/graduate_forum.svg": 74480,
	"./upsell-doorslam/graduate_relax.svg": 65292,
	"./upsell-doorslam/new_words.svg": 63440,
	"./upsell-doorslam/toeic_end.svg": 32239,
	"./upsell-doorslam/unlimited.svg": 7489,
	"./upsell-doorslam/words_limit_reached.svg": 15663,
	"./variations/24x24/animal.svg": 33720,
	"./variations/24x24/beauty.svg": 48566,
	"./variations/24x24/business.svg": 852,
	"./variations/24x24/business_mail.svg": 50826,
	"./variations/24x24/cardinal_numbers.svg": 9121,
	"./variations/24x24/clothes.svg": 53634,
	"./variations/24x24/colours.svg": 86268,
	"./variations/24x24/common_errors.svg": 78780,
	"./variations/24x24/debate.svg": 35153,
	"./variations/24x24/default.svg": 46542,
	"./variations/24x24/democracy.svg": 74543,
	"./variations/24x24/democracy_ua.svg": 20305,
	"./variations/24x24/emotions.svg": 62277,
	"./variations/24x24/environment.svg": 94644,
	"./variations/24x24/ffriends.svg": 62904,
	"./variations/24x24/football.svg": 37504,
	"./variations/24x24/fruits.svg": 42031,
	"./variations/24x24/general.svg": 91614,
	"./variations/24x24/health.svg": 15045,
	"./variations/24x24/hiragana.svg": 9471,
	"./variations/24x24/holiday_in_spain.svg": 25423,
	"./variations/24x24/house.svg": 2902,
	"./variations/24x24/human_body.svg": 11073,
	"./variations/24x24/idioms.svg": 53537,
	"./variations/24x24/junior_1000.svg": 98015,
	"./variations/24x24/kanji.svg": 42822,
	"./variations/24x24/katakana.svg": 77867,
	"./variations/24x24/ko_hangul.svg": 44121,
	"./variations/24x24/law.svg": 55076,
	"./variations/24x24/leisure.svg": 23314,
	"./variations/24x24/lesson.svg": 2857,
	"./variations/24x24/life_abroad.svg": 26269,
	"./variations/24x24/love.svg": 58513,
	"./variations/24x24/medical.svg": 71838,
	"./variations/24x24/news.svg": 89258,
	"./variations/24x24/nutrition.svg": 23703,
	"./variations/24x24/nyt.svg": 66567,
	"./variations/24x24/ordinal_numbers.svg": 62963,
	"./variations/24x24/personal_life.svg": 76159,
	"./variations/24x24/proverbs.svg": 31546,
	"./variations/24x24/quotes.svg": 18770,
	"./variations/24x24/romaji_hiragana.svg": 7267,
	"./variations/24x24/romaji_katakana.svg": 49995,
	"./variations/24x24/ru_cyrillic.svg": 37166,
	"./variations/24x24/science.svg": 67671,
	"./variations/24x24/selectivo.svg": 15551,
	"./variations/24x24/sports_summer.svg": 13132,
	"./variations/24x24/sports_winter.svg": 46819,
	"./variations/24x24/taxi.svg": 86414,
	"./variations/24x24/technology.svg": 36762,
	"./variations/24x24/time_date.svg": 14903,
	"./variations/24x24/toefl.svg": 42498,
	"./variations/24x24/toeic.svg": 49743,
	"./variations/24x24/travel.svg": 13635,
	"./variations/24x24/weather.svg": 26745,
	"./variations/24x24/weekend_in_paris.svg": 9498,
	"./variations/24x24/wizard.svg": 21123,
	"./variations/40x40/animal.svg": 61303,
	"./variations/40x40/beauty.svg": 54658,
	"./variations/40x40/business.svg": 38346,
	"./variations/40x40/business_mail.svg": 30043,
	"./variations/40x40/cardinal_numbers.svg": 53200,
	"./variations/40x40/clothes.svg": 36608,
	"./variations/40x40/colours.svg": 1302,
	"./variations/40x40/common_errors.svg": 44268,
	"./variations/40x40/debate.svg": 1987,
	"./variations/40x40/default.svg": 94409,
	"./variations/40x40/democracy.svg": 12090,
	"./variations/40x40/democracy_ua.svg": 2712,
	"./variations/40x40/emotions.svg": 54407,
	"./variations/40x40/environment.svg": 77735,
	"./variations/40x40/ffriends.svg": 38749,
	"./variations/40x40/football.svg": 64086,
	"./variations/40x40/fruits.svg": 63400,
	"./variations/40x40/general.svg": 94808,
	"./variations/40x40/health.svg": 37096,
	"./variations/40x40/hiragana.svg": 23367,
	"./variations/40x40/holiday_in_spain.svg": 47983,
	"./variations/40x40/house.svg": 10096,
	"./variations/40x40/human_body.svg": 44642,
	"./variations/40x40/idioms.svg": 56671,
	"./variations/40x40/junior_1000.svg": 70343,
	"./variations/40x40/kanji.svg": 83776,
	"./variations/40x40/katakana.svg": 90961,
	"./variations/40x40/ko_hangeul.svg": 8348,
	"./variations/40x40/law.svg": 50744,
	"./variations/40x40/leisure.svg": 67510,
	"./variations/40x40/lesson.svg": 21714,
	"./variations/40x40/life_abroad.svg": 80848,
	"./variations/40x40/love.svg": 17619,
	"./variations/40x40/medical.svg": 92837,
	"./variations/40x40/news.svg": 23831,
	"./variations/40x40/nutrition.svg": 59107,
	"./variations/40x40/nyt.svg": 52515,
	"./variations/40x40/ordinal_numbers.svg": 80638,
	"./variations/40x40/personal_life.svg": 59126,
	"./variations/40x40/proverbs.svg": 58675,
	"./variations/40x40/quotes.svg": 98596,
	"./variations/40x40/romaji_hiragana.svg": 59715,
	"./variations/40x40/romaji_katakana.svg": 73845,
	"./variations/40x40/ru_cyrillic.svg": 93534,
	"./variations/40x40/science.svg": 83197,
	"./variations/40x40/selectivo.svg": 84421,
	"./variations/40x40/sports_summer.svg": 15646,
	"./variations/40x40/sports_winter.svg": 66598,
	"./variations/40x40/taxi.svg": 20246,
	"./variations/40x40/technology.svg": 81991,
	"./variations/40x40/time_date.svg": 39103,
	"./variations/40x40/toefl.svg": 59720,
	"./variations/40x40/toeic.svg": 31074,
	"./variations/40x40/travel.svg": 62464,
	"./variations/40x40/weather.svg": 97009,
	"./variations/40x40/weekend_in_paris.svg": 85442,
	"./variations/40x40/wizard.svg": 97438,
	"./visuals-24x24.svg": 20358,
	"./world-icon.svg": 69042,
	"./x-dismiss-blue.svg": 39488,
	"./x-dismiss.svg": 93775
};


function webpackAsyncContext(req) {
	return webpackAsyncContextResolve(req).then(id => {
		return __webpack_require__.t(id, 3);
	});
}
function webpackAsyncContextResolve(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}
		return map[req];
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.resolve = webpackAsyncContextResolve;
webpackAsyncContext.id = 24498;
module.exports = webpackAsyncContext;